import { Typography } from "@mui/material";

import border from "../assets/border-star.png";

const Heading = ({ text, ...rest }) => (
  <Typography
    component="h1"
    variant="h4"
    {...rest}
    sx={{
      mb: 4,
      textTransform: "uppercase",
      fontWeight: 700,
      letterSpacing: "0.27em",

      "&::after": {
        content: `url(${border})`,
        display: "block",
      },
    }}
  >
    {text}
  </Typography>
);

export default Heading;
